/** German translations. Keys missing here fall back to English (clearly marked in UI). */

import type { EnDictionary } from './en';

export const de: Partial<Record<keyof EnDictionary, string>> = {
  'app.name': 'Traugily',
  'app.tagline': 'Stetiger Fortschritt, einfach gemacht',
  'nav.today': 'Heute',
  'nav.plan': 'Plan',
  'nav.log': 'Protokoll',
  'nav.progress': 'Fortschritt',
  'nav.reports': 'Berichte',
  'nav.calendar': 'Kalender',
  'nav.account': 'Konto',
  'nav.admin': 'Admin',

  'calendar.title': 'Kalender',
  'calendar.prev_month': 'Vorheriger Monat',
  'calendar.next_month': 'Nächster Monat',
  'calendar.blocked': 'Nicht verfügbar',
  'calendar.no_workout': 'Kein Training an diesem Tag.',
  'calendar.begin_workout': 'Training starten',
  'calendar.delete_workout': 'Training löschen',
  'calendar.redo_workout': 'Training löschen & wiederholen',
  'calendar.delete_hint': 'Ein abgeschlossenes Training wird aus deiner Historie entfernt, damit du es wiederholen kannst.',
  'calendar.deleted': 'Training gelöscht.',
  'calendar.reset_for_redo': 'Training zurückgesetzt — es ist wieder geplant und aus der Historie entfernt.',
  'calendar.status.planned': 'Geplant',
  'calendar.status.completed': 'Abgeschlossen',
  'calendar.status.cancelled': 'Abgebrochen',
  'calendar.status.rest': 'Ruhetag',
  'action.begin_workout': 'Training starten',
  'action.resume_workout': 'Training fortsetzen',
  'action.finish_workout': 'Training abschließen',
  'action.save': 'Speichern',
  'action.cancel': 'Abbrechen',
  'action.confirm': 'Bestätigen',
  'action.retry': 'Erneut versuchen',
  'action.back': 'Zurück',
  'action.next': 'Weiter',
  'action.change_password': 'Passwort ändern',
  'action.skip': 'Überspringen',
  'action.sign_in': 'Anmelden',
  'action.sign_up': 'Konto erstellen',
  'action.sign_out': 'Abmelden',
  'action.discard_workout': 'Training verwerfen',
  'action.keep_draft': 'Als Entwurf behalten',
  'action.download': 'Herunterladen',
  'action.generate_report': 'Bericht erstellen',
  'action.accept': 'Akzeptieren',
  'action.reject': 'Vorschlag überspringen',
  'action.close': 'Schließen',
  'state.loading': 'Wird geladen…',
  'state.empty_title': 'Hier ist noch nichts',
  'state.error_title': 'Etwas ist schiefgelaufen',
  'state.offline': 'Sie sind offline. Ihre Änderungen liegen auf diesem Gerät.',
  'state.online': 'Wieder online. Änderungen werden synchronisiert…',
  'state.saved_locally': 'Lokal gespeichert',
  'state.waiting_to_sync': 'Wartet auf Synchronisierung',
  'state.synced': 'Synchronisiert',
  'state.sync_needs_attention': 'Synchronisierung braucht Aufmerksamkeit',
  'state.conflict_title': 'Training wurde auf einem anderen Gerät geändert',
  'state.conflict_body':
    'Nichts wurde überschrieben. Wählen Sie, welche Version Sie behalten möchten — beide Datensätze bleiben verfügbar.',
  'state.conflict_keep_local': 'Änderungen auf diesem Gerät behalten',
  'state.conflict_keep_remote': 'Version des anderen Geräts behalten',
  'state.conflict_discard_confirm': 'Ja, meine nicht synchronisierten Einträge verwerfen',
  'today.title': 'Heute',
  'today.next_action': 'Ihr nächster Schritt',
  'today.no_session': 'Heute ist keine Einheit geplant',
  'today.rest_day': 'Ruhetag — Erholung ist Teil des Plans',
  'today.pending_proposals': '{count} Planvorschläge warten auf Sie',
  'today.unread_notifications': '{count} ungelesene Benachrichtigungen',
  'today.start_onboarding': 'Profil einrichten',
  'today.action.start_workout': 'Heutiges Training starten',
  'today.action.resume_workout': 'Training fortsetzen',
  'today.action.view_plan': 'Plan ansehen',
  'today.action.start_onboarding': 'Einrichtung abschließen',
  'today.action.no_workout_today': 'Heute kein Training — ruh dich gut aus.',
  'today.action.generate_plan': 'Plan erstellen',
  'today.plan_summary': 'Wochenziel: {sessions} Einheiten · je {minutes} Min',
  'plan.title': 'Ihr Plan',
  'plan.phase': 'Aktuelle Phase',
  'plan.phase_remaining': '{weeks} Wochen verbleiben',
  'plan.why': 'Warum dieser Plan',
  'plan.assumptions': 'Annahmen',
  'plan.rest_days': 'Ruhetage pro Woche: {count}',
  'plan.weekly_rhythm': 'Wochenrhythmus',
  'plan.week.training': 'Training',
  'plan.week.rest': 'Ruhe / Erholung',
  'plan.accept_prompt': 'Plan prüfen und akzeptieren, um mit dem Training zu beginnen.',
  'plan.accept_confirm':
    'Mir ist klar, dass Traugily kein medizinischer Dienst ist, und ich suche bei Schmerzen professionelle Hilfe.',
  'plan.accepted': 'Plan aktiviert',
  'plan.length_change': 'Planlänge ändern',
  'plan.length_preview': 'Vergleich vorher/nachher prüfen, bevor Sie bestätigen.',
  'plan.length_before': 'Vorher',
  'plan.length_after': 'Nachher',
  'plan.version': 'Planversion {version}',
  'log.title': 'Trainingsprotokoll',
  'log.history': 'Vergangene Trainingseinheiten',
  'log.no_history': 'Noch keine Trainingseinheiten — die erste beginnt unter „Heute".',
  'log.planned': 'Geplant',
  'log.actual': 'Ausgeführt',
  'log.rest_timer': 'Pausentimer',
  'log.report_pain': 'Beschwerden oder Schmerzen melden',
  'log.pain.discomfort': 'Leichte Beschwerden',
  'log.pain.pain': 'Schmerzen',
  'log.pain.urgent': 'Notfall — Schwindel, Brustschmerz, Ohnmacht',
  'log.finish_summary': 'Zusammenfassung',
  'log.duration': 'Dauer',
  'log.calories': 'Geschätzter Kalorienverbrauch',
  'log.calories_note': 'Nur eine Schätzung — keine medizinische Messung.',
  'log.set_empty': 'Gib Wdh., Gewicht, RPE oder RIR vor dem Speichern ein — leere Sätze werden nicht gespeichert.',
  'log.set_saved': 'Satz gespeichert.',
  'log.set_queued_offline': 'Du bist offline — der Satz ist auf diesem Gerät gespeichert und wird synchronisiert.',
  'log.finish_failed': 'Das Training konnte nicht beendet werden. Bitte versuche es erneut.',
  'safety.guidance.urgent':
    'Brechen Sie das Training sofort ab. Bei Brustschmerzen, Ohnmacht, Schwindel, plötzlicher Atemnot oder ähnlichen Symptomen suchen Sie bitte umgehend medizinische Hilfe. Traugily kann Ihre Symptome nicht beurteilen.',
  'safety.guidance.pain':
    'Danke für den Hinweis. Bitte lassen Sie die Bewegung von einer qualifizierten Fachperson prüfen, bevor Sie sie fortsetzen. Wir erhöhen diese Übung nicht, bis Sie einen sicheren nächsten Schritt wählen.',
  'safety.guidance.discomfort':
    'Leichte Beschwerden kommen vor. Reduzieren Sie Belastung oder Bewegungsumfang und hören Sie auf, wenn es schlimmer wird oder anhält.',
  'safety.guidance.none': 'Danke für Ihre Meldung.',
  'progress.title': 'Fortschritt',
  'progress.weigh_in': 'Wöchentliches Wiegen',
  'progress.weigh_in_hint':
    'Für konsistente Werte: nach dem Toilettengang und vor dem Frühstück wiegen, etwa zur gleichen Zeit pro Woche.',
  'progress.weight': 'Gewicht',
  'progress.trend': 'Trend (gleitender Durchschnitt)',
  'progress.trend_note': 'Trends sind beschreibend — keine Diagnose.',
  'progress.consistency': 'Konstanz',
  'progress.personal_records': 'Persönliche Bestleistungen',
  'progress.goal_review': 'Zielüberprüfung',
  'nutrition.title': 'Ernährung',
  'nutrition.targets': 'Tagesziele (Schätzungen)',
  'nutrition.targets.estimate_notice':
    'Die Ziele sind Schätzungen auf Basis Ihres Profils und werden je Phase angepasst. Keine medizinische Beratung.',
  'nutrition.suggestions': 'Mahlzeitenideen',
  'nutrition.log_meal': 'Mahlzeit eintragen',
  'account.title': 'Konto',
  'account.language': 'Sprache',
  'account.units': 'Einheiten',
  'account.sign_out': 'Abmelden',
  'account.export_data': 'Meine Daten exportieren',
  'account.delete_account': 'Konto löschen',
  'account.plan.free': 'Kostenlos',
  'account.plan.premium': 'Premium',
  'account.subscribe': 'Abonnieren — etwa 5 €/Monat',
  'account.manage_billing': 'Abrechnung verwalten',
  'account.change_password': 'Passwort ändern',
  'account.change_password_heading': 'Passwort ändern',
  'account.password_current': 'Aktuelles Passwort',
  'account.password_new': 'Neues Passwort',
  'account.password_confirm': 'Neues Passwort bestätigen',
  'account.password_requirements': 'Mindestens 10 Zeichen, Groß-, Kleinbuchstabe und Zahl.',

  'account.password_changed': 'Passwort aktualisiert.',

  'account.error.old_password_incorrect': 'Aktuelles Passwort ist falsch.',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.forgot': 'Passwort vergessen?',
  'auth.reset_sent': 'Falls diese E-Mail existiert, ist ein Zurücksetzen-Link unterwegs.',
  'auth.verify_notice': 'Bitte bestätigen Sie Ihre E-Mail — der Link ist in Ihrem Postfach.',
  'auth.google': 'Weiter mit Google',
  'auth.apple': 'Weiter mit Apple',
  'auth.have_account': 'Schon ein Konto?',
  'auth.no_account': 'Neu bei Traugily?',
  'onboarding.title': 'Richten wir Ihren Plan ein',
  'onboarding.step': 'Schritt {current} von {total}',
  'onboarding.save_resume': 'Ihr Fortschritt wird gespeichert — setzen Sie jederzeit fort.',
  'onboarding.safety': 'Sicherheit zuerst',
  'onboarding.safety_ack':
    'Mir ist klar, dass Traugily kein medizinischer Dienst ist, und ich suche bei Schmerzen professionelle Hilfe.',
  'admin.title': 'Admin',
  'admin.no_access': 'Sie haben keinen Zugriff auf diesen Bereich.',
  'admin.grant_premium': 'Premium gewähren',
  'admin.revoke_to_free': 'Auf kostenlos umstellen',
  'reports.title': 'Berichte',
  'reports.period': 'Zeitraum',
  'reports.detail': 'Detailgrad',
  'reports.detail.summary': 'Zusammenfassung',
  'reports.detail.standard': 'Standard',
  'reports.detail.detailed': 'Detailliert',
  'reports.status.pending': 'Ausstehend',
  'reports.status.processing': 'Wird erstellt',
  'reports.status.ready': 'Bereit',
  'reports.status.failed': 'Fehlgeschlagen',
  'reports.download': 'PDF herunterladen',
  'reports.estimate_notice': 'Alle Schätzungen im Bericht sind gekennzeichnet.',
  'reports.start_date': 'Startdatum',
  'reports.end_date': 'Enddatum',
  'reports.language': 'Berichtssprache',
  'reports.history': 'Frühere Berichte',
  'reports.empty': 'Noch keine Berichte',
  'reports.empty_hint': 'Wählen Sie oben einen Zeitraum und erstellen Sie Ihr erstes PDF.',
  'reports.polling': 'Ihr PDF wird erstellt — Status wird geprüft…',
  'reports.error_dates_required': 'Wählen Sie ein Start- und Enddatum.',
  'reports.error_date_order': 'Das Enddatum muss auf oder nach dem Startdatum liegen.',
  'error.network': 'Server nicht erreichbar. Ihre lokalen Änderungen sind sicher.',
  'error.validation': 'Bitte prüfen Sie die markierten Felder.',
  'error.permission': 'Sie haben keine Berechtigung für diese Aktion.',
  'error.generic': 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
  'offline.banner': 'Offline-Modus — Ihre Einträge werden zuerst auf diesem Gerät gespeichert.',
} as const;
